import secureLocalStorage from "react-secure-storage";
import React, { Component } from "react";
import { Popup } from "@progress/kendo-react-popup";
import { PanelBar, PanelBarItem } from "@progress/kendo-react-layout";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { NumericTextBox, TextArea } from "@progress/kendo-react-inputs";
import { Input } from "@progress/kendo-react-inputs";
import Chip from "@material-ui/core/Chip";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { toastr } from "react-redux-toastr";
import Api from "../../../Services/Api";
import { CircularProgress } from "@material-ui/core";
import { DatePicker } from "@progress/kendo-react-dateinputs";
import moment from "moment";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import { dateFieldName, formatNumber } from "@telerik/kendo-intl";
import { Window } from "@progress/kendo-react-dialogs";
import { CustomDateInput } from "../../CustomDateInput";

const ApproveData = [
  { text: "Yes", value: true },
  { text: "No", value: false },
];
const STATUS = [
  { text: "Open", value: true },
  { text: "Closed", value: false },
];
export class ActionRegisterFormView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      impactFieldReq: [],
      formEditFlag: false,
      isDonePopulate: false,
      riskDetails: this.props.riskDetails ? this.props.riskDetails : {},
      formData: {},
      progressStatusFlag: false,
      updateBtnFlag: true,
      actionAlertStakeHolders: [],
      impactslist: [],
      probabilityRangeMaster: {},
      weightageList: [],
      qualitativeImpactslist: [],
      openImpactRatingFlag: false,
      skip: 0,
      take: Math.round((window.innerHeight - 250) / 35),
      probabilityvalue: "",
    };
    this.getDisableFlagForSubmit = this.getDisableFlagForSubmit.bind(this);
  }
  progressHistory = () => {
    this.setState({ ...this.state, progressStatusFlag: true });
  };

  closeProgressHistoryPopup = () => {
    this.setState({ ...this.state, progressStatusFlag: false });
  };
  componentDidMount = () => {
    if (this.props.formEditFlag === true) {
      console.log("vvv", this.props.formData);
      this.loadEditmode(this.props.formData);
    }
  };

  loadEditmode = async (formData) => {
    await this.populateFormData(formData, this.props.riskDetails);
  };
  processInput = (input) => {
    if (typeof input === "string") {
      return input.split(",").map((item) => item.trim()); // Optional: trim spaces around items
    } else if (Array.isArray(input)) {
      return input;
    } else {
      return [];
    }
  };
  populateFormData = async (formData, riskRegister) => {
    try {
      if (formData) {
        this.setState({
          formData: formData,
          isDonePopulate: true,
          riskDetails: riskRegister,
          formEditFlag: true,
          name: formData.name,
          cost: formData.cost,
          reductionFrequency: formData.reductionFrequency,
          spi: formData.spi,
          originalCompletionDate: formData.originalCompletionDate
            ? new Date(formData.originalCompletionDate)
            : null,
          projectedCompletionDate: formData.projectedCompletionDate
            ? new Date(formData.projectedCompletionDate)
            : null,
          actualCompletionDate: formData.actualCompletionDate
            ? new Date(formData.actualCompletionDate)
            : null,
          proximityDate: formData.proximityDate
            ? new Date(formData.proximityDate)
            : null,
          percentageCompletion: formData.percentageCompletion,
          approved: ApproveData.find(
            (item) =>
              item.value === formData.approved ||
              item.text === formData.approved
          ),
          control: formData.control,
          impactFieldReq: await this.constructImpactState(formData),
          alertDescription: formData.alertDescription,
          actionAlertStakeHolders: this.processInput(
            formData.actionAlertStakeHolders
          ),
          delayConsequence: formData.delayConsequence,
          isOpen: STATUS.find(
            (item) =>
              item.value === formData.isOpen || item.text === formData.isOpen
          ),
          externalReference: formData.externalReference,
          departments: formData.departments,
          externalStatus: formData.externalStatus,
          weeklyReport: formData.weeklyReport,
          actionType: formData.actionType
            ? await this.getActionType(formData.actionType)
            : null,
          status: formData.status,
          owner: this.props.ownerListForRisk.find(
            (item) => item.value === formData.userId
          ),
        });
      } else {
        this.setState({
          ...this.state,
          riskDetails: riskRegister,
          formEditFlag: true,
          formData: {},
        });
      }
    } catch (err) {
      console.error(err);
    }
  };
  getActionType = (actionType) => {
    let data = this.props.actionTypeList.find(
      (item) => item.text === actionType
    );
    return data;
  };

  cancelForm = (flag) => {
    if (flag) {
      this.setState({
        loader: false,
        // cancelAndRefreshFlag:false,
        formData: {},
        isDonePopulate: false,
        formEditFlag: false,
        name: null,
        cost: null,
        reductionFrequency: null,
        spi: 0,
        originalCompletionDate: null,
        projectedCompletionDate: null,
        actualCompletionDate: null,
        proximityDate: null,
        percentageCompletion: 0,
        approved: null,
        control: null,
        impactFieldReq: [],
        alertDescription: null,
        actionAlertStakeHolders: [],
        delayConsequence: null,
        isOpen: null,
        externalReference: null,
        departments: null,
        externalStatus: null,
        weeklyReport: null,
        actionType: null,
        status: null,
        owner: null,
      });
      this.props.closeRiskFormView("REFRESH");
    } else {
      this.setState({
        loader: false,
        formData: {},
        isDonePopulate: false,
        formEditFlag: false,
        name: null,
        cost: null,
        reductionFrequency: null,
        spi: 0,
        originalCompletionDate: null,
        projectedCompletionDate: null,
        actualCompletionDate: null,
        proximityDate: null,
        percentageCompletion: 0,
        approved: null,
        control: null,
        impactFieldReq: [],
        alertDescription: null,
        actionAlertStakeHolders: [],
        delayConsequence: null,
        isOpen: null,
        externalReference: null,
        departments: null,
        externalStatus: null,
        weeklyReport: null,
        actionType: null,
        status: null,
        owner: null,
      });
      this.props.closeRiskFormView("CANCEL");
    }
  };
  refreshAction = async () => {
    try {
      let QualityImpact = this.state.impactFieldReq.filter(
        (item) => item.impactType != "Quantitative"
      );
      let QArr = [];
      if (QualityImpact && QualityImpact.length > 0) {
        QualityImpact.map((item) => {
          QArr.push({
            QualitativeImpactId: item.impactId,
            QValue: item.value,
            ProjectRiskActionId:
              this.state.formEditFlag === true
                ? this.state.formData.riskRegisterActionId
                : 0,
          });
        });
      }
      let QuantitativeImpacts = this.state.impactFieldReq.filter(
        (item) => item.impactType === "Quantitative"
      );
      let QnArr = [];

      if (QuantitativeImpacts && QuantitativeImpacts.length > 0) {
        QuantitativeImpacts.map((item) => {
          QnArr.push({
            ImpactId: item.impactId,
            ProjectRiskActionId:
              this.state.formEditFlag === true
                ? this.state.formData
                  ? this.state.formData.riskRegisterActionId
                  : 0
                : 0,
            Value: item.value,
          });
        });
      }

      let request = {
        riskRegisterActionId:
          this.state.formEditFlag === true
            ? this.state.formData.riskRegisterActionId
            : 0,
        riskRegisterId: this.state.riskDetails
          ? this.state.riskDetails.riskRegisterId
          : 0,
        name: this.state.name,
        reductionFrequency: this.state.reductionFrequency,
        spi: this.state.spi,
        approved: this.state.approved ? this.state.approved.value : false,
        createdBy: parseInt(secureLocalStorage.getItem("loginUserId")),
        createdDate: new Date(),
        impactResponse: QnArr,
        QualityImpact: QArr,
        percentageCompletion: this.state.percentageCompletion,
        isOpen:
          this.state.percentageCompletion === 100
            ? false
            : this.state.isOpen
            ? this.state.isOpen.value
            : true,
      };
      let response = await Api.MitigationCalculation(request);
      if (response.status === 200) {
        this.populateRefreshFormData(
          response.riskMitigationResp,
          response.riskRegister[0]
        );
      } else {
        this.setState({ ...this.state, loader: false });
      }
    } catch (err) {
      console.error(err);
      this.setState({ ...this.state, loader: false });
    }
  };
  populateRefreshFormData = async (formData, riskRegister) => {
    try {
      if (formData) {
        this.setState({
          // formData: formData,
          isDonePopulate: true,
          riskDetails: riskRegister,
          reductionFrequency: formData.reductionFrequency,
          impactFieldReq: await this.constructImpactState(formData),
        });
      }
    } catch (err) {
      console.error(err);
    }
  };
  saveAction = async () => {
    try {
      this.setState({ ...this.state, loader: true });
      let QualityImpact = this.state.impactFieldReq.filter(
        (item) => item.impactType != "Quantitative"
      );
      let QArr = [];
      if (QualityImpact && QualityImpact.length > 0) {
        QualityImpact.map((item) => {
          QArr.push({
            QualitativeImpactId: item.impactId,
            QValue: item.value,
            ProjectRiskActionId:
              this.state.formEditFlag === true
                ? this.state.formData.riskRegisterActionId
                : 0,
          });
        });
      }
      let QuantitativeImpacts = this.state.impactFieldReq.filter(
        (item) => item.impactType === "Quantitative"
      );
      let QnArr = [];

      if (QuantitativeImpacts && QuantitativeImpacts.length > 0) {
        QuantitativeImpacts.map((item) => {
          QnArr.push({
            ImpactId: item.impactId,
            ProjectRiskActionId:
              this.state.formEditFlag === true
                ? this.state.formData
                  ? this.state.formData.riskRegisterActionId
                  : 0
                : 0,
            Value: item.value,
          });
        });
      }
      let actualCompletionDate = this.state.actualCompletionDate;
      let projectedCompletionDate = null;
      let originalCompletionDate = null;
      let percentageCompletion = this.state.percentageCompletion;

      if (
        this.state.isOpen?.value === false &&
        this.state.actualCompletionDate &&
        !this.state.originalCompletionDate &&
        !this.state.projectedCompletionDate
      ) {
        // actualCompletionDate = moment(new Date()).format("YYYY-MM-DD");
        projectedCompletionDate = moment(
          this.state.actualCompletionDate
        ).format("YYYY-MM-DD");
        originalCompletionDate = moment(this.state.actualCompletionDate).format(
          "YYYY-MM-DD"
        );
      }

      if (
        this.state.actualCompletionDate &&
        !this.state.originalCompletionDate &&
        !this.state.projectedCompletionDate
      ) {
        projectedCompletionDate = moment(
          this.state.actualCompletionDate
        ).format("YYYY-MM-DD");
        originalCompletionDate = moment(this.state.actualCompletionDate).format(
          "YYYY-MM-DD"
        );
      }
      //new
      if (this.state?.isOpen?.value == true) {
        actualCompletionDate = null;
      }
      if (this.state?.isOpen?.value == false && !actualCompletionDate) {
        actualCompletionDate = moment(new Date()).format("YYYY-MM-DD");
      }
      // if(this.state?.isOpen==false){
      //   percentageCompletion=100;
      // }
      //end
      let request = {
        riskRegisterActionId:
          this.state.formEditFlag === true
            ? this.state.formData.riskRegisterActionId
            : 0,
        riskRegisterId: this.state.riskDetails
          ? this.state.riskDetails.riskRegisterId
          : 0,
        name: this.state.name?.slice(0, 30),
        cost: this.state.cost,
        reductionFrequency:
          this.state.reductionFrequency > 100
            ? 100
            : this.state.reductionFrequency,
        spi: this.state.spi > 100 ? 100 : this.state.spi,
        // percentageCompletion:
        //   percentageCompletion > 100 || this.state.isOpen?.value===false
        //     ? 100
        //     : percentageCompletion,
        percentageCompletion: percentageCompletion,
        originalCompletionDate: this.state.originalCompletionDate
          ? moment(this.state.originalCompletionDate).format("YYYY-MM-DD")
          : originalCompletionDate,
        projectedCompletionDate: this.state.projectedCompletionDate
          ? moment(this.state.projectedCompletionDate).format("YYYY-MM-DD")
          : projectedCompletionDate,
        actualCompletionDate: actualCompletionDate,
        proximityDate: this.state.proximityDate
          ? moment(this.state.proximityDate).format("YYYY-MM-DD")
          : null,
        approved: this.state.approved ? this.state.approved.value : false,
        control: this.state.control,
        createdBy: parseInt(secureLocalStorage.getItem("loginUserId")),
        createdDate: new Date(),
        impactResponse: QnArr,
        QualityImpact: QArr,
        alertDescription: this.state.alertDescription,
        actionAlertStakeHolders: this.processInput(
          this.state.actionAlertStakeHolders
        ),
        delayConsequence: this.state.delayConsequence,
        isOpen:
          percentageCompletion === 100
            ? false
            : this.state.isOpen
            ? this.state.isOpen.value
            : true,
        externalReference: this.state.externalReference,
        departments: this.state.departments,
        externalStatus: this.state.externalStatus,
        weeklyReport: this.state.weeklyReport,
        actionType: this.state.actionType ? this.state.actionType.text : null,
        status: this.state.status,
        userId: this.state.owner ? this.state.owner.value : null,
        owner: this.state.owner ? this.state.owner.text : null,
      };
      let response = await Api.createRegisterMitigation(request);
      if (response.status === 200) {
        toastr.success(response.message);
        await this.populateFormData(
          response.riskMitigationResp,
          response.riskRegister[0]
        );
        // this.setState({ ...this.state, loader: false});
        await this.cancelForm(true);
      } else {
        toastr.error(response.message);
        this.setState({ ...this.state, loader: false });
      }
    } catch (err) {
      console.error(err);
      this.setState({ ...this.state, loader: false });
    }
  };
  handleImpactFieldValue = (e, impact) => {
    try {
      let impactObj = {
        impactId: impact.impactId,
        impactType: impact.impactType,
        value: e.value,
      };
      let arr = this.state.impactFieldReq;
      if (arr.some((item) => item.impactId === impact.impactId)) {
        let index = arr.findIndex((item) => item.impactId == impact.impactId);
        arr[index] = impactObj;
      } else {
        arr.push(impactObj);
      }
      this.setState({ ...this.state, impactFieldReq: arr });
    } catch (err) {
      console.error(err);
    }
  };
  getImpactValue = (impact) => {
    try {
      let impactObj = this.state.impactFieldReq.find(
        (item) => item.impactId === impact.impactId
      );
      if (impactObj && impact.impactType === "Quantitative") {
        return impactObj.value;
      } else if (impactObj && impact.impactType === "Qualitative") {
        return impactObj.qValue ? impactObj.qValue : impactObj.value;
      }
    } catch (err) {
      console.error(err);
    }
    return 0;
  };
  constructImpactState = (formData) => {
    try {
      let arr = [];
      formData.impactResponse &&
        formData.impactResponse.map((impact) => {
          arr.push({
            impactId:
              impact.impactType === "Qualitative"
                ? impact.qualitativeImpactId
                : impact.impactId,
            impactType: impact.impactType,
            value:
              impact.impactType === "Qualitative"
                ? impact.qValue
                : impact.value,
          });
        });
      return arr;
    } catch (err) {
      console.error(err);
    }
    return [];
  };

  CustomHeaderCellForProbablity = () => {
    let riskval = this.state.riskDetails.frequency;
    let actionVal = this.state.riskDetails.reductionProbability;
    let currentProbability = this.state.riskDetails.currentProbability;
    return (
      <span>
        <span className="actionFormHeaderCell" title="Original Value">
          Pre : {riskval}
        </span>

        <span
          className="skyBlueCell reductionProbVal actionFormHeaderCellCurrent"
          title="Current Value"
        >
          {""} Current : {currentProbability ? currentProbability : 0}
        </span>
        <span
          className="yellowCell reductionProbVal actionFormHeaderCell"
          title="Approved Value"
        >
          {""} Post : {actionVal ? actionVal : 0}
        </span>
      </span>
    );
  };
  CustomHeaderCell = (impact) => {
    try {
      let impactPost =
        this.state.riskDetails &&
        this.state.riskDetails.impactResponse &&
        this.state.riskDetails.impactResponse.find(
          (item) => item.impactId == impact.impactId && item.type == "Post"
        );
      let impactPre =
        this.state.riskDetails &&
        this.state.riskDetails.impactResponse &&
        this.state.riskDetails.impactResponse.find(
          (item) => item.impactId == impact.impactId && item.type == "Pre"
        );
      let impactCurrent =
        this.state.riskDetails &&
        this.state.riskDetails.impactResponse &&
        this.state.riskDetails.impactResponse.find(
          (item) => item.impactId == impact.impactId && item.type == "Current"
        );
      let pre = 0;
      let post = 0;
      let current = 0;
      if (impact && impact.impactType == "Quantitative") {
        pre = impactPre ? impactPre.value : 0;
        post = impactPre ? impactPre.postImpactValue : 0;
        current = impactCurrent ? impactCurrent.currentImpactValue : 0;
      } else {
        pre = impactPre ? impactPre.qValue : 0;
        post = impactPost ? impactPost.postQvalue : 0;
        current = impactCurrent ? impactCurrent.currentQvalue : 0;
      }

      return (
        <div>
          <span className="actionFormHeaderCell" title="Pre Value">
            {" "}
            Pre : {formatNumber(pre, "##,#")}
          </span>
          <span
            className="skyBlueCell actionFormHeaderCellCurrent"
            title="Current Value"
          >
            {""} Current : {formatNumber(current, "##,#")}
          </span>
          <span className="yellowCell actionFormHeaderCell" title="Post Value">
            {""} Post : {formatNumber(post, "##,#")}
          </span>
        </div>
      );
    } catch (err) {
      console.error(err);
    }
  };

  getDisableFlag = () => {
    let flag = false;
    const loginUserId = parseInt(secureLocalStorage.getItem("loginUserId"));
    const ownerId = this.state.formData ? this.state.formData.userId : 0;
    const isOpen = this.state.formData
      ? this.state.formData.isOpen === "Closed"
        ? false
        : true
      : null;
    const role = this.props.role;
    const riskOwnerId = this.state.riskDetails
      ? this.state.riskDetails.userId
      : null;

    if (loginUserId === ownerId && isOpen === true) {
      flag = false;
    } else if (
      riskOwnerId === loginUserId &&
      isOpen === true &&
      this.state.formEditFlag === true
    ) {
      flag = false;
    } else if (role === "View Only" || role === "Standard User") {
      flag = true;
    } else if (isOpen === false && this.state.formEditFlag === true) {
      flag = true;
    }
    return flag;
  };

  getDisableFlagForSubmit = () => {
    let flag = false;
    const loginUserId = parseInt(secureLocalStorage.getItem("loginUserId"));
    const ownerId = this.state.formData ? this.state.formData.userId : 0;
    const isOpen = this.state.formData
      ? this.state.formData.isOpen === true ||
        this.state.formData.isOpen === "Open"
        ? true
        : false
      : null;
    const role = this.props.role;
    const riskOwnerId = this.state.riskDetails
      ? this.state.riskDetails.userId
      : null;
    if (loginUserId === ownerId && isOpen === true) {
      flag = false;
    } else if (
      riskOwnerId === loginUserId &&
      isOpen === true &&
      this.state.formEditFlag === true
    ) {
      flag = false;
    } else if (
      (role === "View Only" || role === "Standard User") &&
      riskOwnerId != loginUserId
    ) {
      flag = true;
    } else if (isOpen === false && this.state.formEditFlag === true) {
      flag = true;
    } else if (!this.state.name || this.state.name === "") {
      flag = true;
    }
    return flag;
  };

  isOverdueOriginalCompletionDate = () => {
    let overdue = false;
    let currentdate = new Date();
    const isOpen = this.state.formData.isOpen;
    if (
      (isOpen == "Open" ||
        isOpen == true ||
        isOpen == null ||
        isOpen == undefined) &&
      !this.state.projectedCompletionDate &&
      moment(this.state.originalCompletionDate).toDate() < currentdate
    ) {
      overdue = true;
    }
    if (
      (isOpen == "Open" ||
        isOpen == true ||
        isOpen == null ||
        isOpen == undefined) &&
      this.state.projectedCompletionDate &&
      moment(this.state.originalCompletionDate).toDate() <
        this.state.projectedCompletionDate
    ) {
      overdue = true;
    }
    return overdue == true ? "redCell" : "txtWhite";
  };
  isOverduePercentageCompletion = () => {
    let currentdate = new Date();
    const isOpen = this.state.formData.isOpen;

    // currentdate.setDate(currentdate.getDate() - 1);
    return (isOpen == "Open" || isOpen == true || isOpen == null) &&
      moment(this.state.projectedCompletionDate).toDate() < currentdate
      ? "redCell"
      : "txtWhite";
  };
  alertstackholdervalue = (e, values) => {
    var val = [];
    val = values[values.length - 1];
    let mailvalidity = /^([a-zA-Z0-9\._]+)@([a-zA-Z0-9])+.([a-z]+)(.[a-z]+)?$/;
    if (
      val &&
      (val.trim().length == 0 ||
        (!(val.includes("(") && val.includes(")")) &&
          mailvalidity.test(val) == false))
    ) {
      toastr.error("Please enter a valid email address");
    } else {
      this.setState({
        ...this.state,
        actionAlertStakeHolders: values,
      });
    }
  };

  getImpactRatingTable = async () => {
    try {
      this.setState({ loader: true });
      var req = {
        WorkstreamId: this.props.orgUnit.unitId,
      };
      let response = await Api.getImpactRatingTable(req);
      if (response.status === 200 && response.impactRatingTable) {
        let wlist = response.impactRatios ? response.impactRatios : [];

        this.dynamicColsQuantitative(
          response.impactRatingTable,
          response.probabilityRangeResponse
        );
        this.dynamicColsQualititative(
          response.qualityimpactRatingTable,
          response.probabilityRangeResponse
        );

        let arr = response.probabilityRangeResponse;
        let rangeArray = [];
        let probabilityObj = {};
        let array = response.probabilityRangeResponse;
        let probabilityval = {};

        arr = arr?.map((item) => {
          item[item.fullDescription] = item.probabilityRangeValue;
          probabilityObj = { ...probabilityObj, ...item };
          return item;
        });
        array = array?.map((item) => {
          item[item.probabilityDescription] = item.probabilityRangeValue;
          probabilityval = { ...probabilityval, ...item };
          return item;
        });
        let probabilityArray = array.map((column, index) => (
          <GridColumn
            key={index}
            field={column.probabilityDescription}
            title={column.probabilityDescription + " From"}
            editor="numeric"
            width="110px"
            format="{0:##,#}"
            editable={false}
          />
        ));
        rangeArray = arr.map((column, index) => (
          <GridColumn
            key={index}
            field={column.fullDescription}
            title={column.fullDescription + " From"}
            editor="numeric"
            width="110px"
            format="{0:##,#}"
            editable={false}
          />
        ));

        this.setState({
          ...this.state,
          loader: false,
          openImpactRatingFlag: true,
          impactslist: response.impactRatingTable,
          probabilityRangeMaster: [probabilityval],
          weightageList: wlist,
          qualitativeImpactslist: response.qualityimpactRatingTable,
          probabilityColumns: rangeArray,
          probabilityvalue: probabilityArray,
        });
      } else {
        this.setState({
          ...this.state,
          loader: false,
          impactslist: [],
          probabilityRangeMaster: [],
          weightageList: [],
          qualitativeImpactslist: [],
        });
      }
    } catch (error) {
      console.error(error);
      this.setState({
        ...this.state,
        loader: false,
        impactslist: [],
        probabilityRangeMaster: {},
        weightageList: [],
        qualitativeImpactslist: [],
      });
    }
  };

  dynamicColsQuantitative = (data, probabilityRangeResponse) => {
    try {
      data.map((res) => {
        res.impactThresholdValue.map((item) => {
          let field = this.getFieldName(item.orderId, probabilityRangeResponse);
          res[field] = item.thresholdValue;
        });
      });
    } catch (error) {
      // this.setState({ ...this.state, loader: false });
      console.error(error);
    }
  };
  dynamicColsQualititative = (data, probabilityRangeResponse) => {
    try {
      data.map((res) => {
        res.qualitativeImpactValue.map((item) => {
          let field = this.getFieldName(item.orderId, probabilityRangeResponse);
          res[field] = item.qualitativeValue;
        });
      });
    } catch (error) {
      // this.setState({ ...this.state, loader: false });
      console.error(error);
    }
  };
  getFieldName = (orderId, probabilityRangeResponse) => {
    let obj = probabilityRangeResponse.find((item) => item.orderId === orderId);
    return obj?.fullDescription;
  };
  impactRatingClose = () => {
    this.setState({ openImpactRatingFlag: false });
  };
  openImpactRatingTable = () => {
    this.getImpactRatingTable();
  };
  pageChange = (event) => {
    this.setState({ skip: event.page.skip, take: event.page.take });
  };

  isHiddenActionColumn = (field) => {
    return !this.props.selectedActionsColumnFields?.some(
      (item) => item.fieldName === field
    );
  };
  render() {
    const isDisabled = this.getDisableFlag();
    const {
      openImpactRatingFlag,
      probabilityRangeMaster,
      impactslist,
      weightageList,
      qualitativeImpactslist,
      skip,
      take,
    } = this.state;
    let isPrime = this.props.orgUnit.isPrime ? true : false;

    return (
      <div>
        <Popup
          show={this.props.showFormView}
          popupClass={"popup-content popup-wrapper"}
        >
          <div className="addriskFormview">
            <div className="Formview">
              <h3>
                {this.state.formEditFlag === true
                  ? "Update Action - " + this.state.formData.number
                  : "Add Action"}{" "}
              </h3>
              <div className="RatingTablebtn" title="Rating Table">
                <a onClick={() => this.openImpactRatingTable()}>Rating Table</a>
              </div>
              {this.state.loader ? (
                <span className="MatTableSpinner">
                  <CircularProgress style={{ color: "#FFFFFF" }} size={70} />
                </span>
              ) : null}
            </div>
            <PanelBar expandMode={"multiple"}>
              <PanelBarItem title={"Risk Information"} expanded={true}>
                <div className="riskRow">
                  <div className="riskCol col2">
                    <div
                      className="fieldCont"
                      title={this.props.riskDetails?.riskTitle}
                    >
                      <label>Risk Title</label>

                      <Input
                        value={this.props.riskDetails?.riskTitle}
                        disabled={true}
                      />
                    </div>
                  </div>
                  <div className="riskCol col6">
                    <div
                      className="fieldCont"
                      title={this.props.riskDetails?.name}
                    >
                      <label>Risk Description</label>

                      <Input
                        value={this.props.riskDetails?.name}
                        disabled={true}
                      />
                    </div>
                  </div>
                  <div className="riskCol col2">
                    <div className="fieldCont">
                      <label>Threat / Opportunity</label>
                      <Input
                        value={this.props.riskDetails?.isOpportunity}
                        disabled={true}
                      />
                    </div>
                  </div>
                </div>
              </PanelBarItem>
              <PanelBarItem title={"Action Information"} expanded={true}>
                <div className="riskRow">
                  <div className="riskCol col2">
                    <div className="fieldCont" title={this.state.name}>
                      <label>Action Title *</label>

                      <Input
                        onChange={(e) => {
                          this.setState({
                            ...this.state,
                            name: e.value,
                          });
                        }}
                        value={
                          this.state.name ? this.state.name.trimStart() : ""
                        }
                        disabled={isDisabled}
                      />
                    </div>
                  </div>
                  {this.isHiddenActionColumn("control") && (
                    <div className="riskCol col6">
                      <div className="fieldCont" title={this.state.control}>
                        <label>Action Description</label>

                        <TextArea
                          onChange={(e) => {
                            this.setState({
                              ...this.state,
                              control: e.value,
                            });
                          }}
                          value={this.state.control}
                          disabled={isDisabled}
                        />
                      </div>
                    </div>
                  )}
                  {this.isHiddenActionColumn("cost") && (
                    <div className="riskCol col2">
                      <div className="fieldCont">
                        <label>
                          Cost Of Action / {secureLocalStorage.getItem("currency")}
                        </label>
                        <NumericTextBox
                          value={this.state.cost}
                          onChange={(e) => {
                            this.setState({
                              ...this.state,
                              cost: e.target.value,
                            });
                          }}
                          disabled={isDisabled}
                        />
                      </div>
                    </div>
                  )}
                </div>
                <div className="riskRow">
                  {this.isHiddenActionColumn("externalReference") && (
                    <div className="riskCol col4">
                      <div
                        className="fieldCont"
                        title={this.state.externalReference}
                      >
                        <label>External Reference</label>
                        <TextArea
                          onChange={(e) => {
                            this.setState({
                              ...this.state,
                              externalReference: e.value,
                            });
                          }}
                          value={this.state.externalReference}
                          disabled={isDisabled}
                        />
                      </div>
                    </div>
                  )}
                  {this.isHiddenActionColumn("actionType") && (
                    <div className="riskCol col4">
                      <div className="fieldCont" title={this.state.actionType}>
                        <label>Action Type</label>
                        <DropDownList
                          style={{ width: "100px" }}
                          onChange={(e) => {
                            this.setState({
                              ...this.state,
                              actionType: e.target.value,
                            });
                          }}
                          value={this.state.actionType}
                          data={this.props.actionTypeList}
                          valueField="value"
                          textField="text"
                          disabled={isDisabled}
                        />
                      </div>
                    </div>
                  )}
                  {this.isHiddenActionColumn("delayConsequence") && (
                    <div className="riskCol col4">
                      <div
                        className="fieldCont"
                        title={this.state.delayConsequence}
                      >
                        <label>Delay Consequence</label>

                        <TextArea
                          onChange={(e) => {
                            this.setState({
                              ...this.state,
                              delayConsequence: e.value,
                            });
                          }}
                          value={this.state.delayConsequence}
                          disabled={isDisabled}
                        />
                      </div>
                    </div>
                  )}
                  {this.isHiddenActionColumn("status") && (
                    <div className="riskCol col4">
                      <div className="fieldCont" title={this.state.status}>
                        <label>Progress Status</label>

                        <TextArea
                          onChange={(e) => {
                            this.setState({
                              ...this.state,
                              status: e.value,
                            });
                          }}
                          value={this.state.status}
                          disabled={isDisabled}
                        />
                      </div>
                    </div>
                  )}

                  {this.state.formEditFlag === true &&
                  this.isHiddenActionColumn("status") ? (
                    <div className="riskCol col2">
                      <div
                        className="fieldCont progressHistory"
                        title="Progress History"
                        style={{ marginTop: "26px" }}
                      >
                        {/* <a
                          className="greenbtn"
                          onClick={() => this.progressHistory()}
                        >
                          <img src={Images.HISTORY} width="25" alt="More" />
                        </a> */}
                        <button
                          className="btnPrimary"
                          onClick={() => this.progressHistory()}
                        >
                          Progress History
                        </button>
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
                <div className="riskRow">
                  {this.isHiddenActionColumn("owner") && (
                    <div className="riskCol col2">
                      <div className="fieldCont">
                        <label>Action Owner</label>
                        <DropDownList
                          // style={{ width: "100px" }}
                          onChange={(e) => {
                            this.setState({
                              ...this.state,
                              owner: e.target.value,
                            });
                          }}
                          value={this.state.owner}
                          data={this.props ? this.props.ownerListForRisk : []}
                          valueField="value"
                          textField="text"
                          disabled={isDisabled}
                        />
                      </div>
                    </div>
                  )}
                  {this.isHiddenActionColumn("approved") && (
                    <div className="riskCol col2">
                      <div className="fieldCont">
                        <label>Approved</label>
                        <DropDownList
                          style={{ width: "100px" }}
                          onChange={(e) => {
                            this.setState({
                              ...this.state,
                              approved: e.target.value,
                            });
                          }}
                          data={ApproveData}
                          valueField="value"
                          textField="text"
                          value={this.state.approved}
                          disabled={isDisabled}
                        />
                      </div>
                    </div>
                  )}
                  {this.isHiddenActionColumn("isOpen") && (
                    <div className="riskCol col2">
                      <div className="fieldCont">
                        <label>Status</label>
                        <DropDownList
                          value={this.state.isOpen}
                          onChange={(e) => {
                            this.setState({
                              ...this.state,
                              isOpen: e.target.value,
                              percentageCompletion:
                                this.state.percentageCompletion === 100 &&
                                e.target.value.text === "Open"
                                  ? 0
                                  : this.state.percentageCompletion,
                              actualCompletionDate:
                                e.target.value.text === "Open"
                                  ? null
                                  : this.state.actualCompletionDate,
                              updateBtnFlag:
                                e.target.value.text === "Open" ? false : true,
                            });
                          }}
                          data={STATUS}
                          valueField="value"
                          textField="text"
                          // disabled={isDisabled}
                        />
                      </div>
                    </div>
                  )}
                </div>
              </PanelBarItem>

              <PanelBarItem title={"Additional Information"}>
                <div className="riskRow">
                  {this.isHiddenActionColumn("departments") && (
                    <div className="riskCol col4">
                      <div className="fieldCont" title={this.state.departments}>
                        <label>Departments</label>

                        <TextArea
                          onChange={(e) => {
                            this.setState({
                              ...this.state,
                              departments: e.value,
                            });
                          }}
                          value={
                            this.state.departments
                              ? this.state.departments.trimStart()
                              : ""
                          }
                          disabled={isDisabled}
                        />
                      </div>
                    </div>
                  )}
                  {this.isHiddenActionColumn("externalStatus") && (
                    <div className="riskCol col2">
                      <div
                        className="fieldCont"
                        title={this.state.externalStatus}
                      >
                        <label>External Status</label>

                        <Input
                          onChange={(e) => {
                            this.setState({
                              ...this.state,
                              externalStatus: e.value,
                            });
                          }}
                          value={
                            this.state.externalStatus
                              ? this.state.externalStatus.trimStart()
                              : ""
                          }
                          disabled={isDisabled}
                        />
                      </div>
                    </div>
                  )}
                  {this.isHiddenActionColumn("weeklyReport") && (
                    <div className="riskCol col1">
                      <div
                        className="fieldCont"
                        title={this.state.weeklyReport}
                      >
                        <label>Weekly Report</label>

                        <Input
                          onChange={(e) => {
                            this.setState({
                              ...this.state,
                              weeklyReport: e.value,
                            });
                          }}
                          value={
                            this.state.weeklyReport
                              ? this.state.weeklyReport.trimStart()
                              : ""
                          }
                          disabled={isDisabled}
                        />
                      </div>
                    </div>
                  )}
                </div>
              </PanelBarItem>
              {this.isHiddenActionColumn("reductionFrequency") && (
                <PanelBarItem title={"Probability"}>
                  <div className="riskRow">
                    <div className="riskCol col3">
                      <div className="fieldCont">
                        <label>
                          {this.state.riskDetails.isOpportunity ===
                          "Opportunity"
                            ? "Increase in Probability (%)"
                            : "Reduction in Probability (%)"}
                        </label>
                        <NumericTextBox
                          value={
                            this.state.reductionFrequency > 100
                              ? 100
                              : this.state.reductionFrequency
                          }
                          onChange={(e) => {
                            this.setState({
                              ...this.state,
                              reductionFrequency: e.target.value,
                            });
                          }}
                          min={0}
                          max={100}
                          disabled={isDisabled}
                        />
                      </div>
                    </div>
                    <div className="riskCol col3">
                      <div
                        className="fieldCont"
                        style={{ "padding-top": "24px" }}
                      >
                        {this.CustomHeaderCellForProbablity()}
                      </div>
                    </div>
                  </div>
                </PanelBarItem>
              )}

              <PanelBarItem title={"Impacts"} className="Impactsfiled">
                {/* <div className="riskRow"> */}
                {this.props.orgUnit &&
                  this.props.orgUnit.impactThresholds &&
                  this.props.orgUnit.impactThresholds.map((impact) => {
                    return (
                      <div className="riskRow" key={impact.impactId}>
                        <div className="riskCol col3">
                          <div className="fieldCont">
                            <label>
                              {this.state.riskDetails.isOpportunity ===
                              "Opportunity"
                                ? "Increase in "
                                : "Reduction in "}
                              {impact.impactType === "Quantitative"
                                ? impact.impactName + " / " + impact.units
                                : impact.impactName}
                            </label>
                            {impact.impactType === "Quantitative" ? (
                              <NumericTextBox
                                value={this.getImpactValue(impact)}
                                onChange={(e) =>
                                  this.handleImpactFieldValue(e, impact)
                                }
                                disabled={isDisabled}
                              />
                            ) : (
                              <DropDownList
                                style={{ width: "100px" }}
                                onChange={(e) =>
                                  this.handleImpactFieldValue(e, impact)
                                }
                                value={this.getImpactValue(impact)}
                                data={[0, 1, 2, 3, 4, 5, 6, 7, 8].slice(
                                  0,
                                  this.props.heatMapCount + 1
                                )}
                                disabled={isDisabled}
                              />
                            )}
                          </div>
                        </div>
                        <div className="riskCol col3">
                          <div
                            className="fieldCont"
                            style={{ "padding-top": "24px" }}
                          >
                            {this.CustomHeaderCell(impact)}
                          </div>
                        </div>
                      </div>
                    );
                  })}
                {/* </div> */}
              </PanelBarItem>

              <PanelBarItem title={"Action Progress"}>
                <div className="riskRow">
                  {this.isHiddenActionColumn("spi") && (
                    <div className="riskCol col3">
                      <div className="fieldCont">
                        <label>% On Track</label>
                        <NumericTextBox
                          value={this.state.spi}
                          onChange={(e) => {
                            this.setState({
                              ...this.state,
                              spi: e.target.value > 100 ? 100 : e.target.value,
                            });
                          }}
                          min={0}
                          max={100}
                          disabled={isDisabled}
                        />
                      </div>
                    </div>
                  )}
                  {this.isHiddenActionColumn("percentageCompletion") && (
                    <div className="riskCol col3">
                      <div className="fieldCont">
                        <label>% Completion</label>
                        <NumericTextBox
                          value={this.state.percentageCompletion}
                          onChange={(e) => {
                            this.setState({
                              ...this.state,
                              percentageCompletion:
                                e.target.value > 100 ? 100 : e.target.value,
                            });
                          }}
                          min={0}
                          max={100}
                          disabled={isDisabled}
                        />
                      </div>
                    </div>
                  )}
                </div>
                <div className="riskRow">
                  {this.isHiddenActionColumn("originalCompletionDate") && (
                    <div className="riskCol col3">
                      <div className="fieldCont">
                        <label
                          className={this.isOverdueOriginalCompletionDate()}
                        >
                          Original Completion Date
                        </label>
                        <DatePicker
                          format="dd-MMM-yyyy"
                          value={this.state.originalCompletionDate}
                          onChange={(e) =>
                            this.setState({
                              ...this.state,
                              originalCompletionDate: e.target.value,
                              projectedCompletionDate: e.target.value,
                            })
                          }
                          // defaultShow={true}
                          disabled={isDisabled}
                          dateInput={CustomDateInput}
                        />
                      </div>
                    </div>
                  )}
                  {this.isHiddenActionColumn("projectedCompletionDate") && (
                    <div className="riskCol col3">
                      <div className="fieldCont">
                        <label className={this.isOverduePercentageCompletion()}>
                          Projected Completion Date
                        </label>

                        <DatePicker
                          format="dd-MMM-yyyy"
                          value={this.state.projectedCompletionDate}
                          onChange={(e) =>
                            this.setState({
                              ...this.state,
                              projectedCompletionDate: e.target.value,
                              originalCompletionDate: this.state
                                .originalCompletionDate
                                ? this.state.originalCompletionDate
                                : e.target.value,
                            })
                          }
                          // defaultShow={true}
                          disabled={isDisabled}
                          dateInput={CustomDateInput}
                        />
                      </div>
                    </div>
                  )}
                  {this.isHiddenActionColumn("actualCompletionDate") && (
                    <div className="riskCol col3">
                      <div className="fieldCont">
                        <label>Actual Completion Date</label>

                        <DatePicker
                          format="dd-MMM-yyyy"
                          value={this.state.actualCompletionDate}
                          onChange={(e) =>
                            this.setState({
                              ...this.state,
                              actualCompletionDate: e.target.value,
                              isOpen: STATUS[1],
                            })
                          }
                          max={new Date()}
                          disabled={isDisabled}
                          dateInput={CustomDateInput}
                        />
                      </div>
                    </div>
                  )}
                </div>
              </PanelBarItem>
              <PanelBarItem title={"Proximity Alert"}>
                <div className="riskRow">
                  {this.isHiddenActionColumn("proximityDate") && (
                    <div className="riskCol col5">
                      <div className="fieldCont">
                        <label>Proximity Alert Date</label>

                        <DatePicker
                          format="dd-MMM-yyyy"
                          value={this.state.proximityDate}
                          onChange={(e) =>
                            this.setState({
                              ...this.state,
                              proximityDate: e.target.value,
                            })
                          }
                          // defaultShow={true}
                          disabled={isDisabled}
                          dateInput={CustomDateInput}
                        />
                      </div>
                      <div className="fieldCont" style={{ marginTop: "15px" }}>
                        <label>Alert Stakeholders</label>
                        <Autocomplete
                          multiple
                          id="emailbcc"
                          // autoSelect={true}
                          options={
                            this.props.dropDownData &&
                            this.props.dropDownData.map(
                              (option) => option.displayName
                            )
                          }
                          freeSolo
                          disableCloseOnSelect
                          onChange={this.alertstackholdervalue}
                          value={this.state.actionAlertStakeHolders}
                          disabled={isDisabled}
                          renderTags={(value, getTagProps) =>
                            value.map((option, index) => (
                              <Chip
                                variant="outlined"
                                label={option}
                                {...getTagProps({ index })}
                              />
                            ))
                          }
                          PaperComponent={({ children }) => (
                            <div className="paperComponent">
                              <span>{children}</span>
                            </div>
                          )}
                          renderInput={(params) => (
                            <TextField {...params} variant="filled" />
                          )}
                        />
                      </div>
                    </div>
                  )}

                  {this.isHiddenActionColumn("alertDescription") && (
                    <div className="riskCol col5">
                      <div
                        className="fieldCont textarea-large"
                        title={this.state.alertDescription}
                      >
                        <label>Alert Description</label>
                        <TextArea
                          value={this.state.alertDescription}
                          onChange={(e) => {
                            this.setState({
                              ...this.state,
                              alertDescription: e.value,
                            });
                          }}
                          disabled={isDisabled}
                        />
                      </div>
                    </div>
                  )}
                </div>
              </PanelBarItem>
            </PanelBar>
            <div className="btnGroup">
              {this.state.formEditFlag === true && (
                <button
                  type="button"
                  onClick={this.refreshAction}
                  className="btnPrimary"
                  disabled={
                    (this.getDisableFlagForSubmit() &&
                      this.state.updateBtnFlag) ||
                    !this.state.approved?.value
                  }
                >
                  Refresh
                </button>
              )}
              <button
                type="button"
                onClick={this.saveAction}
                className="btnPrimary"
                disabled={
                  this.getDisableFlagForSubmit() && this.state.updateBtnFlag
                }
              >
                {this.state.formEditFlag === true ? "Update" : "Add"}
              </button>
              <button
                className="btnPrimary"
                onClick={() => this.cancelForm(false)}
              >
                Cancel
              </button>
            </div>
          </div>
        </Popup>
        <Popup
          show={this.state.progressStatusFlag}
          popupClass={"popup-content popup-wrapper"}
        >
          <div className="deleteModelCont stackHolderSelection">
            <label className="fieldLabel">Progress History</label>
            <div className="commentsHistory">
              <ul className="comments">
                {this.state.formData.actionImpactComments &&
                  this.state.formData.actionImpactComments.map((item) => (
                    <li>
                      <p>{item.actionComment}</p>
                      <small>
                        Date:
                        {moment(new Date(item.createdDate)).format(
                          "DD-MMM-yyyy HH:mm:ss"
                        )}
                      </small>{" "}
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
                      <small>Entered by:{item.userName}</small>
                    </li>
                  ))}
              </ul>
            </div>
            <div className="progressBtn">
              <button
                onClick={this.closeProgressHistoryPopup}
                className="redbtn"
                type="button"
                style={{ "margin-left": "700px", "margin-bottom": "15px" }}
              >
                Cancel
              </button>
            </div>
          </div>
        </Popup>
        {openImpactRatingFlag && (
          <Window
            title={"Rating Table"}
            onClose={this.impactRatingClose}
            className="ratingTable"
            initialLeft={250}
            initialTop={200}
            initialWidth={680}
            initialHeight={530}
            resizable={false}
            minimizeButton={() => null}
            maximizeButton={() => null}
            restoreButton={() => null}
          >
            <div className=" ratingTablegrid ">
              <div className="Probabilitytable">
                <label>Probability Range</label>
                <Grid
                  data={probabilityRangeMaster}
                  reorderable
                  resizable
                  // total={impactslist.length}
                >
                  {this.state.probabilityvalue}
                </Grid>
              </div>

              <br></br>
              <div className="Quantitativetable">
                <label>Quantitative rating table</label>
                <Grid
                  data={impactslist.slice(skip, take + skip)}
                  reorderable
                  resizable
                  skip={skip}
                  take={take}
                  total={impactslist.length}
                  pageable={true}
                  onPageChange={this.pageChange}
                >
                  <GridColumn
                    field="name"
                    title="Impact"
                    width="150"
                    cell={(props) => (
                      <td
                        title={
                          props.dataItem.name ? props.dataItem.name : "Default"
                        }
                      >
                        {props.dataItem.name ? props.dataItem.name : "Default"}
                      </td>
                    )}
                  />
                  {this.state.probabilityColumns}
                </Grid>
              </div>

              <br></br>
              <div className="Qualitativetable">
                <label>Qualitative rating table</label>
                <Grid
                  data={qualitativeImpactslist.slice(skip, take + skip)}
                  reorderable
                  resizable
                  skip={skip}
                  take={take}
                  total={qualitativeImpactslist.length}
                  pageable={true}
                  onPageChange={this.pageChange}
                >
                  <GridColumn
                    field="name"
                    title="Name"
                    width="150"
                    cell={(props) => (
                      <td>
                        {props.dataItem.name ? props.dataItem.name : "Default"}
                      </td>
                    )}
                  />
                  {this.state.probabilityColumns}
                </Grid>
              </div>
              <br></br>
              {isPrime == true && secureLocalStorage.getItem("isPrime") == true ? (
                <div className="Primetable">
                  <label>Prime Weightings</label>
                  <Grid
                    data={weightageList.slice(skip, take + skip)}
                    reorderable
                    resizable
                    skip={skip}
                    take={take}
                    total={weightageList.length}
                    pageable={true}
                    onPageChange={this.pageChange}
                  >
                    <GridColumn
                      field="impactVariable"
                      title="Impact variable"
                      width="150"
                    />
                    <GridColumn field="ratio" title="Weighting" width="100" />
                  </Grid>
                </div>
              ) : (
                ""
              )}
            </div>
          </Window>
        )}
      </div>
    );
  }
}

export default ActionRegisterFormView;
